var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 36,
    viewBox: "0 0 60 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2689 1C33.6612 1 34.7899 2.1193 34.7899 3.5V33.5C34.7899 34.8807 33.6612 36 32.2689 36C30.8766 36 29.7479 34.8807 29.7479 33.5V3.5C29.7479 2.1193 30.8766 1 32.2689 1Z",
    fill: "#263681"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9495 15C55.3418 15 56.4705 16.1193 56.4705 17.5V33C56.4705 34.3807 55.3418 35.5 53.9495 35.5C52.5572 35.5 51.4285 34.3807 51.4285 33V17.5C51.4285 16.1193 52.5572 15 53.9495 15Z",
    fill: "#263681"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8571 15C44.2494 15 45.3781 16.1193 45.3781 17.5V33C45.3781 34.3807 44.2494 35.5 42.8571 35.5C41.4648 35.5 40.3361 34.3807 40.3361 33V17.5C40.3361 16.1193 41.4648 15 42.8571 15Z",
    fill: "#263681"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6806 15C23.0729 15 24.2016 16.1193 24.2016 17.5V33C24.2016 34.3807 23.0729 35.5 21.6806 35.5C20.2883 35.5 19.1596 34.3807 19.1596 33V17.5C19.1596 16.1193 20.2883 15 21.6806 15Z",
    fill: "#263681"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9977 1.81767C32.3777 2.22137 32.3557 2.85417 31.9485 3.23107L1.69646 31.2311C1.28932 31.6079 0.651209 31.5861 0.271213 31.1823C-0.108794 30.7786 -0.0867904 30.1458 0.320362 29.7689L30.7563 1.49997C31.1634 1.12317 31.6176 1.41387 31.9977 1.81767Z",
    fill: "#263681"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6898 15.83C54.0629 16.2401 54.0302 16.8724 53.6167 17.2424L33.7815 35.5C33.368 35.87 31.8933 36.08 31.5202 35.67C31.1471 35.26 31.1798 34.6276 31.5932 34.2576L52.4369 15.5C52.8504 15.13 53.3167 15.42 53.6898 15.83Z",
    fill: "#263681"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5982 15.831C42.9707 16.2415 42.9373 16.8738 42.5233 17.2433L23.1933 35C22.7793 35.3695 21.3037 35.5795 20.9311 35.169C20.5585 34.7585 20.5921 34.1262 21.006 33.7567L41.3445 15.5C41.7584 15.1305 42.2256 15.4205 42.5982 15.831Z",
    fill: "#263681"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3853 15.7929C21.7791 16.1834 21.7791 16.8166 21.3853 17.2071L18.3601 20.2071C17.9663 20.5976 17.3278 20.5976 16.934 20.2071C16.5402 19.8166 16.5402 19.1834 16.934 18.7929L19.6639 16C20.0576 15.6095 20.9915 15.4024 21.3853 15.7929Z",
    fill: "#263681"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.779 29.8753C60.1269 30.3066 60.0564 30.9359 59.6215 31.2809L55.4621 35C55.0272 35.345 53.51 35.556 53.1621 35.1247C52.8142 34.6934 52.8847 34.0641 53.3196 33.7191L58.3616 29.7191C58.7965 29.3741 59.4311 29.444 59.779 29.8753Z",
    fill: "#263681"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6866 29.8753C49.0345 30.3066 48.964 30.9359 48.5291 31.2809L44.3697 35C43.9348 35.345 42.4175 35.556 42.0696 35.1247C41.7217 34.6934 41.7922 34.0641 42.2272 33.7191L47.2692 29.7191C47.7041 29.3741 48.3387 29.444 48.6866 29.8753Z",
    fill: "#263681"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3529 1C43.5294 2.5 45.1764 6.4 42.3529 10",
    stroke: "#263681",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8907 1C48.0672 2.5 49.7142 6.4 46.8907 10",
    stroke: "#263681",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9243 1C52.1008 2.5 53.7478 6.4 50.9243 10",
    stroke: "#263681",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.0d45f65141b0ef35054c0b8912653700.svg";
export { ForwardRef as ReactComponent };